module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADzSURBVEhL7dUva0JRHMbxG6bzD2vbizBNg8GmbTBYsonJd7VkEYtiEBURxL2F1VWTf0AWLCrz+zAPjHHSOb8kPvBB0/fK5dxrchtL4x3fmOAJZlN8gJ8/PmFyEV/cGSFqivfhi8sOwUuhB1/YaSN4XfiizhQZBK0IX9SZIYfgleELyxxR8Tcc4It/ICquVXHE//gCeUQte/lswF3kFTXcIWrPWEK3SHtB6/dr/BRfQb9YZ990OpJrKD6Enl6zlbCB4nqvmMUrqGMLxccwixdwgsKid/s9zNaBi8sjzPaAPVz8C+7sm03nXP9GTUQ/PNeyJDkDoVhfOLRqG60AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-screwdriver/dark/24.png
// module id = 2404
// module chunks = 2